import { DateTime, Duration } from "luxon";
import i18n from "@/plugins/i18n";
import formatcoords from "formatcoords";

export default {
  API_DTFORMAT: "yyyy-MM-dd'T'HH:mm:ss",
  API_DTSFORMAT: "yyyy-MM-dd'T'HH:mm:ssZZ",
  API_DFORMAT: "yyyy-MM-dd",

  joinString: function(separator, ...strings) {
    const nonEmptyStrings = strings.filter(str => str !== null && str !== "");

    return nonEmptyStrings.join(separator);
  },

  formatLocation: function(location, withcountry) {
    let result = "";
    let isroad;

    if (location === null)
      return result;

    if (location.road != null) {
      result += location.road;
      isroad = true;

      if (location.houseNumber != null)
        result += " " + location.houseNumber;
    } else
      isroad = false;

    if (location.city != null) {
      if (result.length > 0)
        result += ", " + location.city;
      else
        result += location.city;

      if (!isroad && location.houseNumber != null)
        result += " " + location.houseNumber;
    } else {
      let p = location.county || location.state || location.stateDistrict;

      if (p != null) {
        if (result.length > 0)
          result += ", " + p;
        else
          result += p;
      }
    }

    if (withcountry)
      result += ", " + location.countryCode.toUpperCase();

    return result;
  },

  formatNumber(value, precision = 2) {
    if (value !== null && value !== undefined)
      return parseFloat(value.toFixed(precision)).toLocaleString(i18n.locale);
    else
      return "";
  },

  /**
   * Formátování vzdálenosti
   * @param disatnce vzdálenost v metrech
   */
  formatDistance(disatnce) {
    return (parseInt(disatnce / 100) / 10).toLocaleString(i18n.locale) + " km";
  },

  /**
   * Formátování motohodin
   * @param enginehours motohodiny v sekundách
   */
  formatEngineHours(enginehours) {
    return parseInt((enginehours / (60 * 60)) * 10) / 10 + " h";
  },

  /**
   * Formátování  tachometru
   * @param value Stav tachometru v metrech
   */
  formatOdometer(value) {
    return parseInt(value / 1000).toLocaleString(i18n.locale) + " km";
  },

  /**
   * Formátování období {years: n, months: n, days: n}
   * @param value Obdob9
   */
  formatPeriod(value) {
    const filteredValue = Object.fromEntries(
      // eslint-disable-next-line no-unused-vars
      Object.entries(value).filter(([_, value]) => value !== null && value !== 0));
    const duration = Duration.fromObject(filteredValue);

    return duration.toHuman({
      unitDisplay: "long"
    });
  },

  /**
   * Formátování množství paliva
   *
   * @param value vzdálenost v metrech
   */
  formatFuel(value, change) {
    if (change !== null && change !== undefined && change !== 0) {
      if (change > 0)
        return value + " l (+" + change + " l)";
      else
        return value + " l (" + change + " l)";
    } else
      return value + " l";
  },

  rotateDeg: function(value, deg) {
    let v = (value + deg) % 360;

    if (v < 0)
      return 360 + v;
    else
      return v;
  },

  /**
   * Funkce vrací stav vozidla.
   * NEW - nové vozidlo, žádná data nejsou načtena
   * ACTIVE - vozidlo je aktivně sledováno
   * FAIL - vozidlo nekomunikuje
   *
   * @param vehicle Objekt vozidla
   * @returns {string} state
   */
  vehicleState: function(vehicle) {
    if (vehicle.location === undefined || vehicle.location === null)
      return "NEW";

    let timeout;
    if (vehicle.device !== null && vehicle.device.inactiveTimeout !== undefined)
      timeout = vehicle.device.inactiveTimeout;
    else
      timeout = 1440;

    if (-DateTime.fromISO(vehicle.location.timestamp).diffNow("minutes").get("minutes") <= timeout)
      return "ACTIVE";
    else
      return "FAIL";
  },

  personRoles: function(person, viewall = false) {
    var result = [];

    if (person.superuser)
      result.push("superuser");
    if (person.admin)
      result.push("admin");
    if (person.dispatcher)
      result.push("dispatcher");
    if (person.driver)
      result.push("driver");
    if (viewall && person.viewAll)
      result.push("viewall");

    return result;
  },

  /**
   * Checks if a given object has a value.
   *
   * @param {any} object - The object to be checked.
   * @returns {boolean} - Returns true if the object has a value, false otherwise.
   */
  isValue(object) {
    return object !== "undefined" && object;
  },

  isObjectEmpty(someObject) {
    return !(Object.keys(someObject).length);
  },

  nullString(str) {
    if (str === undefined || str === null || str.length === 0)
      return null;
    else
      return str;
  },

  isNumber(obj) {
    if (obj === undefined || obj === null || (typeof obj === "string" && obj.trim().length === 0))
      return false;
    else
      return (typeof obj === "number" ||
        (typeof obj === "string" && !isNaN(obj) && !isNaN(parseFloat(obj.replace(i18n.tc("lang.decimal_separator"), ".")))));
  },

  toNumber(str) {
    if (str === undefined || str === null || (typeof str === "string" && str.trim().length === 0))
      return null;
    else if (Number.isInteger(str))
      return Number(str);
    else
      return Number(str.replace(i18n.tc("lang.decimal_separator"), "."));
  },

  numberToString(num, precision = 2, fixed = false) {
    if (num === undefined || num === null)
      return null;
    else if (Number.isInteger(num) && !fixed)
      return num.toString();
    else
      return num.toFixed(precision).toString().replace(".", i18n.tc("lang.decimal_separator"));
  },

  objectOrNull(num) {
    if (num === undefined || num === null)
      return null;
    else
      return num;
  },

  /**
   * Převede nvalues hodnoty ze senzor nádrže na string
   *
   * @param nvalues [{n=, values=}, ...]
   * @returns Čitelný řetězec
   */
  nvaluesToString(nvalues) {
    return nvalues.map(x => x.n + "=" + x.value).join("; ");
  },

  /**
   * Převede řetězec na nvalues hodnoty pro sensor nádrž.
   *
   * @param str řetězec
   * @returns [{n=, values=}, ...]
   */
  stringToNValues(str) {
    return str.split(";")
      .map(x => x.trim())
      .map(x => {
        let p = x.split("=");
        if (p.length !== 2)
          throw "Invalid pvalues";

        let n = this.parseInteger(p[0]);
        let v = this.parseInteger(p[1]);

        if (isNaN(n) || isNaN(v))
          throw "Invalid pvalues";

        return { n: n, value: v };
      });
  },

  parseInteger(x) {
    if (/^\s*(\+|-)?\d+\s*$/.test(String(x))) {
      return parseInt(x, 10);
    }
    return Number.NaN;
  },

  formatHours(mins, seconds = false, showzeros = true) {
    if (seconds) {
      let h = Math.trunc(mins / (60 * 60));
      let m = Math.trunc((mins - h * 60 * 60) / 60);
      if (h === 0 && !showzeros)
        return m + "m";
      else
        return h + "h " + m + "m";
    } else {
      let h = Math.trunc(mins / 60);
      if (h === 0 && !showzeros)
        return (mins - h * 60) + "m";
      else
        return h + "h " + (mins - h * 60) + "m";
    }
  },

  wait(func, tm_array) {
    var index = 0;

    function step_wait() {
      if (func())
        return;

      setTimeout(function() {
        index += 1;
        if (index < tm_array.length) {
          step_wait();
        }
      }, tm_array[index]);
    }

    step_wait();
  },

  tachographActivityIcon(activity) {
    switch (activity) {
      case 0:
        return "mdi-bed";
      case 1:
        return "mdi-square-off-outline";
      case 2:
        return "mdi-hammer-screwdriver";
      case 3:
        return "mdi-steering";
      default:
        return "mdi-lert-circle-outline";
    }
  },

  formatCoords(lat, lon) {
    return formatcoords(lat, lon).format();
  },

  /**
   * Zpočítá průměrnou spotřebu l/100km.
   *
   * @param consumption Celková spotřeba v l
   * @param distance Vzdálenost v metrech
   * @param vehicle Vozidlo pro ziskání limitů (consumptionMinKm, consumptionMaxKm)
   * @returns {null|number} Spotřeba
   */
  averageDistanceConsumption(consumption, distance, vehicle) {
    if (distance >= 500) {
      const result = consumption / (distance / 100000);
      const min = (vehicle !== null && vehicle.consumptionMinKm !== null) ? vehicle.consumptionMinKm : 0.0;
      const max = (vehicle !== null && vehicle.consumptionMaxKm !== null) ? vehicle.consumptionMaxKm : 200.0;

      if (result >= min && result <= max)
        return result;
      else
        return null;
    } else
      return null;
  },

  /**
   * Zpočítá průměrnou spotřebu l/100km.
   *
   * @param consumption Celková spotřeba v l
   * @param engineHours Motohodiny v sekundách
   * @param vehicle Vozidlo pro ziskání limitů (consumptionMinMh, consumptionMaxMh)
   * @returns {null|number} Spotřeba
   */
  averageEngineHoursConsumption(consumption, engineHours, vehicle) {
    if (engineHours >= 300) {
      const result = consumption / (engineHours / (60 * 60));
      const min = (vehicle !== null && vehicle.consumptionMinEh !== null) ? vehicle.consumptionMinEh : 0.0;
      const max = (vehicle !== null && vehicle.consumptionMaxEh !== null) ? vehicle.consumptionMaxEh : 400.0;

      if (result >= min && result <= max)
        return result;
      else
        return null;
    } else
      return null;
  },

  /**
   * Rozšíří období do konce dne.
   *
   * @param period Obdnobí
   * @returns {{name, from, to: *}}
   */
  periodToEndDay(period) {
    return {
      name: period.name,
      from: period.from,
      to: DateTime.fromISO(period.to).plus({ "seconds": 86399 }).toFormat()
    };
  },

  /**
   * Formátování jmená, pokud je fname nepovinné.
   *
   * @param fname Jméno
   * @param lname Příjmení
   * @returns {string|*}
   */
  formatName(fname, lname) {
    if (fname === undefined || fname === null)
      return lname;
    else
      return fname + " " + lname;
  },

  /**
   * Vrátí první not null parametr,  jinak vrátí null
   */
  notNullValueOtherNull() {
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i] !== undefined && arguments[i] !== null)
        return arguments[i];
    }

    return null;
  },

  /**
   * Formátuje hodnotu s akcelerometru.
   *
   * @param value Hodnota s akcelerometru.
   */
  formatG(value) {
    return this.numberToString(value / 100, 2, true) + "g";
  },

  /**
   * Vrátí třídu pro formátování qulity podle hodnoty.
   *
   * @param value Kvalita řízení
   * @returns {string}
   */
  colorClassQuality(value) {
    if (value < 2)
      return "green--text text--darken-2";
    else if (value < 3.5)
      return "orange--text";
    else
      return "red--text";
  },

  formatAmount(amount, currency) {
    if (amount == null)
      return null;
    else if (currency !== null)
      return this.numberToString(amount, 2, true) + " " + currency.toUpperCase();
    else
      return this.numberToString(amount, 2, true);
  },

  formatWeight(weight, empty = true) {
    if (weight === undefined || weight === null || weight === 0)
      return (empty) ? "" : "0,0t";
    else
      return this.numberToString(weight / 1000, 1, true) + "t";

  },

  formatVolts(minivolts) {
    if (minivolts === undefined || minivolts === null)
      return "-";
    else
      return this.numberToString(minivolts / 1000, 1, true) + "V";

  },

  toAxleWeight(axles, weight) {
    if (axles == null)
      return [];

    var result = [];
    var rear = false;
    var index = 0;

    axles.forEach(x => {
      if (x.startsWith("rear")) {
        if (rear === false) {
          rear = true;
          if (result.length > 0)
            result.push({
              symbol: "⎯",
              weight: null
            });
        }
      }

      result.push({
        symbol: (x.endsWith("_w")) ? "⬤" : "◯",
        weight: this.formatWeight(weight[index])
      });

      index += 1;
    });

    return result;
  },

  getIdentificationType(code) {
    if (code === null || code === undefined)
      return null;
    else if (code === "dallas_id")
      return "dallas";
    else if (code === "tacho_id")
      return "tachograph";
    else
      return null;
  },

  toClipboard(text) {
    navigator.clipboard.writeText(text);
  },

  /*
   * Odstranění diakritiky
   */
  normalize(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  },

  /*
   * Vyhledá podřetězec ignoruje velikost písmen a diakritiku.
   */
  searchNormalized(str, substring) {
    return this.normalize(str).toLowerCase().includes(this.normalize(substring).toLowerCase());
  },

  /*
   * Spočítá aktuální kavlitu řízení z pozice
  */
  calcDriverQuality(location) {
    return (((location.deceleration / 100) + (location.acceleration / 100)) * 10) + 1;
  },

  formatRouteName(route, index, none = "-") {
    if (route !== undefined && route !== null) {
      if (index < 0)
        index = route.waypoints.length + index;

      if (index >= 0 && index < route.waypoints.length) {
        const waypoint = route.waypoints[index];

        if (waypoint.name === null) {
          const coord = route.path[(index >= route.parts.length)
            ? route.parts[route.parts.length - 1].fromIndex
            : route.parts[index].fromIndex];
          return this.formatCoords(coord[1], coord[0]);
        } else
          return waypoint.name;
      }
    }

    return none;
  },

  parsePeriod(period) {
    if (period === null)
      return { years: 0, months: 0, days: 0 };

    const periodPattern = /(\d+)([yrmdYRMD])/g;
    const periodMatches = period.matchAll(periodPattern);
    const periodObj = { years: 0, months: 0, days: 0 };

    for (const match of periodMatches) {
      const value = parseInt(match[1]);
      const unit = match[2];

      switch (unit.toLowerCase()) {
        case "y":
        case "r":
          periodObj.years += value;
          break;
        case "m":
          periodObj.months += value;
          break;
        case "d":
          periodObj.days += value;
          break;
      }
    }

    return periodObj;
  },

  periodToString(periodObject) {
    let result = "";

    if (periodObject !== undefined && periodObject !== null) {
      if (periodObject.years > 0)
        result += periodObject.years + "r";
      if (periodObject.months > 0) {
        if (result.length > 0) result += " ";
        result += periodObject.months + "m";
      }
      if (periodObject.days > 0) {
        if (result.length > 0) result += " ";
        result += periodObject.days + "d";
      }
    }

    return result;
  }

};
